import { render } from "./SendReceipt.vue?vue&type=template&id=63f9e327&scoped=true"
import script from "./SendReceipt.vue?vue&type=script&lang=js"
export * from "./SendReceipt.vue?vue&type=script&lang=js"

import "./SendReceipt.vue?vue&type=style&index=0&id=63f9e327&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63f9e327"]])

export default __exports__